module.exports = __webpack_public_path__ + "static/media/Sky.132476ed.png";